export const compareDate = (date: Date, secondDate: Date) => {
  return (
    date.getFullYear() == secondDate.getFullYear() &&
    date.getMonth() == secondDate.getMonth() &&
    date.getDate() == secondDate.getDate()
  );
};
